module.exports = __webpack_public_path__ + "static/img/1.52a160e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/1.png
// module id = KVzM
// module chunks = 0